export const PREMIUM_PERKS = 'premium_perks';
export const RELEASE_ANNOUNCEMENT = 'release_announcement';
export const SL_GROWTH_FREEMIUM_AND_PLANS_RELEASE_PARENT =
  'sl_growth_freemium_and_plans_release_parent';
export const SL_HISTORIC_CHARTS = 'SL_historic_charts';
export const SL_WEB_CAM_SURF_HEIGHTS = 'sl_web_cam_surf_heights';
export const SL_WEB_CHARTS_LOCATION_MENU = 'sl_web_charts_location_menu';
export const SL_WEB_CHARTS_SWELL_RULER = 'sl_web_charts_swell_ruler';
export const SL_WEB_CUSTOM_FORECASTS = 'sl_web_custom_forecasts';
export const SL_WEB_FORECAST_FEEDBACK_FREQUENCY = 'sl_web_forecast_feedback_frequency';
export const SL_WEB_PAYWALLS_V2 = 'sl_web_paywalls_v2';
export const SL_WEB_SUNBUM_SPONSORSHIP = 'sl_web_sunbum_sponsorship';
export const SL_WEB_WAVE_POOL_SEARCH_RESULTS = 'sl_web_wave_pool_search_results';
export const SL_WEB_ACCOUNT_SHARING_REDIRECT = 'sl_web_account_sharing_redirect';
export const SL_WEB_PREMIUMPLUS_LIMITED_TIME_ACCESS = 'sl_web_premiumplus_limited_time_access';
export const SL_SCIENCE_POC_CONDITION_SIMILARITY = 'SL_science_poc_condition_similiarity';
export const SL_WEB_HIGH_QUALITY_REWIND_CLIPS_STILLS = 'sl_web_high_quality_rewind_clips_stills';
export const SL_WEB_CAMERA_USER_FEEDBACK_MODAL = 'SL_web_camera_user_feedback_modal';
export const SL_WEB_ACCOUNT_SHARING_BANNER = 'sl_web_account_sharing_banner';
export const SL_WEB_CAM_PAYWALL_REDESIGN = 'sl_web_cam_paywall_redesign';
export const SL_WEB_MANUAL_SESSION_CUSTOM_LOCATION = 'SL_web_manual_session_custom_location';
export const SL_WEB_EDITORIAL_PAYWALL_CUSTOMIZATION = 'sl_web_editorial_paywall_customization';
export const SL_WEB_LIVE_CAM_REWIND_SHARING = 'sl_web_live_cam_rewind_sharing';
export const SL_WEB_REMOVE_ADS_FROM_PREMIUM = 'sl_web_remove_ads_from_premium';
export const SL_WEB_CONTENT_CAROUSEL = 'sl_web_content_carousel';
export const SL_WEB_KBYG_GREEN = 'sl_web_kbyg_green';
export const SL_WEB_FREEMIUM_CAM_HIGHLIGHTS = 'sl_web_freemium_cam_highlights';
export const SL_WEB_FREEMIUM_HOURLY_DATA = 'sl_web_freemium_hourly_data';
export const SL_WEB_TABLE_VIEW_HOURLY = 'sl_web_table_view_hourly';
export const SL_WEB_RATE_SURF = 'sl_web_rate_surf';
export const SL_SURFTILER_NEARSHORE = 'sl_surftiler_nearshore';
export const SL_SURFTILER_ISOLINES = 'sl_surftiler_isolines';
export const SL_SURFTILER_MODEL_SELECTOR = 'sl_surftiler_model_selector';
export const BW_IOS_OCEAN_CURRENTS_LAYER = 'bw_ios_ocean_currents_layer';
export const BW_IOS_WIND_AND_CURRENTS_LAYER = 'bw_ios_wind_and_currents_layer';
export const SL_WEB_GETAPP_QR_CODE_BUTTON = 'sl_web_getapp_qr_code_button';
export const SL_WEB_ANON_YOUTUBE_HOMEPAGE = 'sl_web_anon_youtube_homepage';
export const SL_WEB_LINEUP_CAM_PAYWALL = 'sl_web_lineup_cam_paywall';
export const SL_WEB_FORECAST_GRAPHS_MODERNIZATION = 'SL_web_forecast_graphs_modernization';
export const SL_WEB_FRIEND_FEED = 'sl_web_friend_feed';
export const SL_WEB_CAM_MATCHES = 'SL_web_cam_matches';
export const SL_WEB_FREESTAR_MIGRATION = 'web_freestar_migration';
export const SL_WEB_SPOT_RECOMMENDATIONS = 'sl_web_spot_recommendations';
